module.exports = __webpack_public_path__ + "img/powered.9dc79b73.svg";